import 'jquery-zoom';

$('.zoom-wrapper').each((_, elm) => {
  $(elm).zoom();
});
